export default __webpack_public_path__ + "static/media/javascript_tutorial.e0d28bc4.pdf";